import { useState } from "react";
import SortedHeader from "../../../components/Tables/SortedHeader";
import { useTranslation } from "react-i18next";
export default function BusinessAreaList({
  list,
  setCreateOrEdit,
  setForDelete,
  searchObject,
  setSearchObject
}) {
  let { t } = useTranslation();

  const [headers, setHeaders] = useState([
    { label: t("Business Area Name"), field: "Description" },
    { label: "" }
  ]);

  return (
    <div className="table-wrap quiz-management">
      <table>
        <thead>
          <SortedHeader
            searchObject={searchObject}
            setSearchObject={setSearchObject}
            headers={headers}
            setHeaders={setHeaders}
          />
        </thead>
        <tbody>
          {list.map((businessArea) => (
            <tr>
              <td className="skill-name text-truncate">
                {t(businessArea.description)}
              </td>

              <td className="actions">
                <button
                  onClick={() => setCreateOrEdit(businessArea.id)}
                  className="action-button-settings"
                  type="button"
                >
                  <i class="bi bi-pencil-square"></i>
                </button>

                <button
                  onClick={() => setForDelete(businessArea)}
                  className="action-button-settings"
                  type="button"
                >
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
